import { type FC, memo } from 'react';
import StandardJackpot from '../../StandardJackpot';
import type { StandardJackpotProps } from '../../../types/jackpot.types';
import { useSeasonalBrandingJackpotPanel } from 'store/featureFlags/featureFlagsStore';

import styles from './VipBellLink.module.css';

const VipBellLinkJackpot: FC<StandardJackpotProps> = (props) => {
  const seasonalBranding = useSeasonalBrandingJackpotPanel();
   
  const vipBellLinkIcons = {
    panel: seasonalBranding ? `/brandings/${seasonalBranding}/group_vip_bell_link/panel` : '/group_vip_bell_link/panel',
    grand: '/group_vip_bell_link/grand', // Use BellLink icons instead of Vip BellLink icons
    major: '/group_vip_bell_link/major',
    minor: '/group_vip_bell_link/minor',
    mini: '/group_vip_bell_link/mini',
  };

  return (
    <StandardJackpot
      {...props}
      icons={vipBellLinkIcons}
      className={styles.vipBellLinkTheme}
    />
  );
};

export default memo(VipBellLinkJackpot);
